import { render, staticRenderFns } from "./ThreadRepliesExpansionPanel.vue?vue&type=template&id=4db37e0a&scoped=true"
import script from "./ThreadRepliesExpansionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThreadRepliesExpansionPanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ThreadRepliesExpansionPanel.vue?vue&type=style&index=0&id=4db37e0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db37e0a",
  null
  
)

export default component.exports